/* eslint-disable */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, TextField, Typography, Grid, MenuItem, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import AuthServices from '../services/auth';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [alertType, setAlertState] = useState('');
  const [apiMessage, setMessageState] = useState('');
  var query = window.location.search.substring(1);

  return (
    <>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs={12} md={6} className='logoContainer'
          textAlign="center">
          <img src='/logo_black.png' alt="iCapital" className='logo' />
        </Grid>
        <Grid item xs={11} md={6} className='displayBoxBorder'>
          <img src='/key.png' alt="key" className='key' />
          <Box style={{ width: 'auto', margin: '20px' }}>
            {apiMessage != '' &&
              <Box mb={3}>
                <Alert severity={alertType}>
                  {apiMessage}
                </Alert>
              </Box>
            }
            <Box>
              <Typography
                variant="h4"
                align="left"
              >
                <b>Forgot Password?</b>
              </Typography>
            </Box>
            <Formik
              initialValues={{
                email: '',
                method: '',
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().max(50).required('Username or email is required'),
                method: Yup.string().required('Please select a method to receive your OTP'),
              })}
              onSubmit={async (data) => {
                setAlertState('');
                setMessageState('');
                try {
                  var response = await AuthServices.resetPassword(data);
                  let success = response.data.success;
                  document.getElementsByTagName('form')[0].reset();
                  setAlertState('success');
                  setMessageState(success);
                  setTimeout(() => {
                    navigate('/reset-password?' + query, { replace: true });
                  }, 2000);
                } catch (e) {
                  let error = e.response.data.message;
                  setAlertState('error');
                  setMessageState(error);
                }
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                values,
                isSubmitting,
                touched
              }) => (
                <form onSubmit={handleSubmit}>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    label={'Your username or email'}
                    placeholder="eg. johnsmith / johnsmith@gmail.com"
                    margin="normal"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    variant="standard"
                  />

                  <TextField
                    select
                    error={Boolean(touched.method && errors.method)}
                    helperText={touched.method && errors.method}
                    name={"method"}
                    label={'Receive OTP By'}
                    value={values.method}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="standard"
                    fullWidth
                  >
                    <MenuItem value="email">Email</MenuItem>
                    <MenuItem value="sms">Mobile Number</MenuItem>
                  </TextField>

                  <Box my={2}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      {'Reset Password'}
                    </Button>
                  </Box>
                  <Typography
                    color="textSecondary"
                    variant="body1"
                    align="center"
                  >
                    <Link
                      to={"/?" + query}
                      color="secondary"
                      underline="none"
                    >
                      {'Return to Login'}
                    </Link>{' '}
                  </Typography>
                </form>
              )}
            </Formik>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ForgotPassword;